module.exports = __webpack_public_path__ + "static/img/113.962e444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/113.jpg
// module id = C5wu
// module chunks = 2